var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("NaturalEntityForm", {
        ref: "naturalEntityFormRef",
        attrs: {
          services: _vm.services,
          naturalEntityId: _vm.naturalEntityId,
          naturalEntity: _vm.naturalEntity,
          isEmployee: _vm.isEmployee,
          employee: _vm.employee,
          isComplement: _vm.isComplement
        }
      }),
      _c(
        "vs-popup",
        {
          attrs: {
            fullscreen: "",
            title: "Cadastrar Cônjuge",
            active: _vm.showNaturalEntityCreateForm
          },
          on: {
            "update:active": function($event) {
              _vm.showNaturalEntityCreateForm = $event
            }
          }
        },
        [
          _c("NaturalEntityForm", {
            attrs: {
              services: _vm.services,
              naturalEntityId: null,
              hide_spouse: "true"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }